export default "__VITE_ASSET__XXB41QzC__"